import {SET_IS_AUTHENTICATED} from "./types";

export const setIsAuthenticated = payload => async dispatch => dispatch({type: SET_IS_AUTHENTICATED, payload})

